import React, { useMemo, useCallback } from 'react';
import {
  HeadingMediumH5,
  BodyTextRegularB,
  BodyTextMediumA,
} from '@/shared/ui/typography2';
import { formatCurrency } from '@/shared/libs/format-currency';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Image } from '@/shared/ui/image';
import { WraperOptions, OptionItem, InfoEl } from './styles';

const COIN_IMAGES = {
  0: '/images/coin/bronze.svg',
  1: '/images/coin/silver.svg',
  2: '/images/coin/gold.svg',
};

export const OptionsBlock = React.memo(
  ({ options, changeConditionActve, conditionActve, t, mobileLandscape }) => {
    const handleOptionClick = useCallback(
      (index) => {
        changeConditionActve(index);
      },
      [changeConditionActve]
    );

    const shouldRender = useMemo(() => options?.length > 1, [options?.length]);
    const { user } = useUser();

    const optionsList = useMemo(
      () =>
        options?.map((el, i) => ({
          ...el,
          index: i,
          isActive: i === conditionActve,
          coinImage: COIN_IMAGES[i] || COIN_IMAGES[0],
        })) || [],
      [options, conditionActve]
    );

    if (!shouldRender) return null;

    return (
      <WraperOptions>
        {optionsList.map(({ text, minDeposit, index, isActive, coinImage }) => (
          <OptionItem
            key={`${text}-${minDeposit}-${index}`}
            onClick={() => handleOptionClick(index)}
            $isActive={isActive}
          >
            <Image
              width={mobileLandscape ? 40 : 48}
              height={mobileLandscape ? 40 : 48}
              src={coinImage}
              alt="coin"
            />
            <InfoEl>
              <BodyTextMediumA color={isActive ? '#FF9F0A' : '#fff'}>
                {text}
              </BodyTextMediumA>
              <BodyTextRegularB color="#AFAFAF">
                {t('card.deposit_from', {
                  value: formatCurrency(minDeposit, {
                    currency: user.currency,
                    currencySymbol: user.currencySymbol,
                  }),
                })}
              </BodyTextRegularB>
            </InfoEl>
          </OptionItem>
        ))}
      </WraperOptions>
    );
  }
);
